import './index.css';

import App from './App';
import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import ReactGA from 'react-ga';
require('dotenv').config();

ReactGA.initialize(process.env.REACT_APP_G_TAG || '');
ReactGA.pageview(window.location.pathname + window.location.search);

const container = document.getElementById('root');

const root = createRoot(container!);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
